import { Component, OnInit, Input } from '@angular/core';
import {DomSanitizer, SafeResourceUrl, Title} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TermsService } from '../shared/services/terms.service';
import { TermsAcceptance } from '../shared/models/terms-acceptance.model';
import { SessionStorageService } from '../shared/services/session-storage.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  @Input() public isWaiting: boolean;
  public isChecked: boolean;

  private b64: string;
  private termsAcceptance: TermsAcceptance;
  private uid: string;

  public TOSpdf: SafeResourceUrl;
  public TOSpdfLink: any;

  constructor(private sanitizer: DomSanitizer,
              private router: Router,
              private termsService: TermsService,
              private sessionStorageService: SessionStorageService,
              private titleService: Title) {
    this.uid = this.sessionStorageService.getUserId();
    this.b64 = this.termsService.terms.terms;
    this.termsAcceptance = {
      userId: this.uid,
      version: this.termsService.terms.version
    }
  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: Terms & Conditions');
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      this.TOSpdfLink = window.navigator.msSaveOrOpenBlob(this.convertDataURIToBinary(this.b64), "TermsAndConditions.pdf");
    } else {
      this.TOSpdf = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + this.b64);
    }
  }

  public onFormSubmit() {
    this.termsService.accept(this.termsAcceptance, this.uid).then( () => {
      this.router.navigate(['/loan-images']);
    })
  }

  convertDataURIToBinary(base64) {
    let pdfData = atob(base64);
    let uInt8ArrayPdf = new Uint8Array(pdfData.length);

    for(let i = 0; i < pdfData.length; i++) {
      uInt8ArrayPdf[i] = pdfData.charCodeAt(i);
    }
    let blob = new Blob([uInt8ArrayPdf], {type: 'application/pdf'});
    return blob;
  }

}
